import HTTP from '@/http';
//TODO: This is not implemented anywhere yet because the backend doesn't support it. (c) Kyle Logue
const getDealerCampaigns = async (dealerId) => {
    const response = await new HTTP().get(`dealers/${dealerId}/platforms/pinterest/campaigns`);

    return response.data;
};

export default getDealerCampaigns;
